import AuthWall from '../../../../components/auth-wall';
import '../networkAnalysisPage.scss';
import './generate-report.scss';
import {observer} from 'mobx-react';
import {Navigate, useSearchParams} from 'react-router-dom';
import useGenerateReportController from './useGenerateReportController';
import {Button} from '@carbon/react';
import {DocumentExport} from '@carbon/icons-react';
import GeneratedReport from './components/GeneratedReport';
import ToastNotifications from '../../components/toast-notifications';
import {useContext, useState} from 'react';
import {NetworkContext} from '../../lib/context';


function GenerateReport() {
    const [searchParams] = useSearchParams();
    const standardType = searchParams.get('standard_type') || '';
    const standardVersion = searchParams.get('standard_version') || '';
    const store = useContext(NetworkContext);

    const {
        data: {
            rosterId,
            clientName,
            mapsLoading,
            tablesLoading,
            specialtyGroupings,
            maxTimeDistData,
            providerAvgTimeDistData,
            facilityAvgTimeDistData,
            allSpecialtyCountyData
        },
        methods: {
            printReport
        }
    } = useGenerateReportController();

    const [mapsProgress, setMapsProgress] = useState({current: 0, total: 0});

    const handleReportComplete = () => {
        store.showToastNotification(
            'success',
            'Report ready',
            'Export is now available.',
            {timeout: 6000}
        );
    };

    if (!rosterId) return <Navigate to="/network-optimization/my-files" replace />;

    return (
        <AuthWall>
            <>
                <div className="network-analysis-page generate-report-page pt-5 bg-white border-b border-background-gray-200 items-center">
                    <div className="flex justify-end export-button">
                        <Button
                            renderIcon={DocumentExport}
                            onClick={printReport}
                            disabled={mapsLoading || tablesLoading}
                        >
                            Export
                        </Button>
                    </div>
                    <GeneratedReport
                        clientName={clientName}
                        specialtyGroupings={specialtyGroupings}
                        maxTimeDistData={maxTimeDistData}
                        providerAvgTimeDistData={providerAvgTimeDistData}
                        facilityAvgTimeDistData={facilityAvgTimeDistData}
                        allSpecialtyCountyData={allSpecialtyCountyData}
                        standardType={standardType}
                        standardVersion={standardVersion}
                        onMapsProgressChange={setMapsProgress}
                        mapsProgress={mapsProgress}
                        onReportComplete={handleReportComplete}
                    />
                </div>

                {/* Toast Notifications Queue */}
                <ToastNotifications />
            </>
        </AuthWall>
    );
}

export default observer(GenerateReport);
